/*机构相关
i:get || post
h:requestGet ||requestPost
*/
import axios from '../axios'
export default {
    getAboutInfo: (group_id) => {//机构关于我们的信息
        return axios.requestGet('/v1/mechanisms/desc/'+group_id);
    },
    getAppInfo: (group_id) => {//下载app的信息
        return axios.get('/api/api/app/'+group_id);
    },
    getAppInfo2: (group_id,app_type) => {//下载app的信息 -- 直播使用的
        return axios.get('/api/api/app/'+group_id+'/info/'+app_type);
    },
    
}